import { stripePlans } from "@gosaas/types/stripe";
import type { Product } from "@/components/ui/pricing-table";
import { isBillingApiPricingEnabled } from "@/lib/modules";
import { API_PRICING_BASE_QUERIES } from "@/utils/api-pricing";

const formatCurrency = (amount: number, currency = "USD") => {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency,
		minimumFractionDigits: 2,
	}).format(amount / 100);
};

export const mapStripePlansToProducts = (
	plans: typeof stripePlans,
): Product[] => {
	return plans.map((plan) => {
		const monthlyPrice = plan.monthlyPrice;
		const yearlyPrice = plan.yearlyPrice;
		const baseApiQueries = isBillingApiPricingEnabled()
			? API_PRICING_BASE_QUERIES[plan.name]
			: undefined;

		return {
			id: plan.productId,
			name: plan.name,
			description: plan.description,
			recommendedText: plan.name === "Team" ? "Best value" : undefined,
			apiQueriesIncluded: baseApiQueries,
			price: {
				primaryText: formatCurrency(monthlyPrice.amount),
				secondaryText: `/ ${monthlyPrice.interval}`,
			},
			priceAnnual: yearlyPrice
				? {
						primaryText: formatCurrency(yearlyPrice.amount),
						secondaryText: `/ ${yearlyPrice.interval}`,
					}
				: undefined,
			items: plan.features.map((feature) => ({
				primaryText: feature.name,
			})),
		};
	});
};

export const StripePlansToProducts = mapStripePlansToProducts(stripePlans);
